@if (topicsList()?.length > 0) {
    <mulo-keywords class="margin-bottom-sm display-block">
        @for (topic of topicsList(); track topic) {
            <mulo-keyword-item>
                {{ topic | defaultTranslate: { default: topic } }}
            </mulo-keyword-item>
        }
    </mulo-keywords>
}
@if (description()) {
    <mulo-expandable
        [ratio]="5"
        [expandLabel]="'research.portal.fulldisplay.abstract.expand' | translate"
        [collapseLabel]="'research.portal.fulldisplay.abstract.collapse' | translate"
        class="abstract"
    >
        <span [innerHTML]="description() | htmlEscape: false"></span>
    </mulo-expandable>
}
@if (keywordsList()?.length > 0) {
    <mulo-keywords class="margin-bottom-sm display-block">
        @for (keyword of keywordsList(); track keyword) {
            <mulo-keyword-item>
                {{ keyword | defaultTranslate: { default: keyword } }}
            </mulo-keyword-item>
        }
    </mulo-keywords>
}
